import { useTheme } from "@mui/material/styles";

export const formatVerificationOutcome = (outcome: string): string =>
  outcome
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());

export const getVerificationStatusColor = (status: string): string => {
  const theme = useTheme();

  switch (status) {
    case "QUEUED":
      return theme.palette.info.main;
    case "IN_PROGRESS":
    case "REVIEW":
      return theme.palette.warning.main;
    case "COMPLETED":
      return theme.palette.success.main;
    case "SKIPPED":
      return theme.palette.info.main;
    case "ARCHIVED":
      return theme.palette.info.main;
    default:
      return "#000";
  }
};

export const getVerificationOutcomeColor = (outcome: string): string => {
  const theme = useTheme();

  switch (outcome) {
    case "COVERAGE_ACTIVE_HAS_ORTHO":
      return theme.palette.success.main;
    case "COVERAGE_ACTIVE_NO_ORTHO":
    case "COVERAGE_INACTIVE":
    case "INSUFFICIENT_DATA":
    case "CARRIER_UNAVAILABLE":
    case "PATIENT_NOT_FOUND":
      return theme.palette.error.main;
    case "ALREADY_VERIFIED":
    case "NOT_REQUIRED":
    case "SECONDARY_INSURANCE":
      return theme.palette.info.main;
    default:
      return "#000";
  }
};

export const useVerificationColors = () => {
  const theme = useTheme();

  const getStatusColor = (status: string): string => {
    switch (status) {
      case "QUEUED":
        return theme.palette.info.main;
      case "IN_PROGRESS":
        return theme.palette.warning.main;
      case "REVIEW":
        return theme.palette.secondary.main;
      case "COMPLETED":
        return theme.palette.success.main;
      case "SKIPPED":
        return theme.palette.info.main;
      case "ARCHIVED":
        return theme.palette.info.main;
      default:
        return "#000";
    }
  };

  const getOutcomeColor = (outcome: string): string => {
    switch (outcome) {
      case "COVERAGE_ACTIVE_HAS_ORTHO":
        return theme.palette.success.main;
      case "COVERAGE_ACTIVE_NO_ORTHO":
      case "COVERAGE_INACTIVE":
      case "INSUFFICIENT_DATA":
      case "CARRIER_UNAVAILABLE":
      case "PATIENT_NOT_FOUND":
        return theme.palette.error.main;
      case "ALREADY_VERIFIED":
      case "NOT_REQUIRED":
      case "SECONDARY_INSURANCE":
        return theme.palette.info.main;
      default:
        return "#000";
    }
  };

  return { getStatusColor, getOutcomeColor };
};
